export default "e29afc4440919096.svg"